// <auto-generated>
// This file is automatically generated by the CLI.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2026-09-04T05:48:19.674Z
// </auto-generated>

/**
 * Entity name → the ROOT React Query key its generated hooks use, i.e. the first
 * element of `['<root>', tenantId, …]` in `<entity>Keys.all`.
 *
 * Emitted alongside the hooks from the one pluralisation the generator uses, so a
 * caller that only knows an entity's NAME — a push notification naming what it
 * changed, a deep link — can reach that entity's caches and its list route without
 * re-deriving the plural (`Country` → `countries`, `NumberSeries` → `numberseries`:
 * a hand-rolled `+ 's'` is wrong for 11 of the entities here).
 */
export const entityQueryKeyRoots: Record<string, string> = {
  Account: 'accounts',
  AccountDerivationRule: 'accountderivationrules',
  AccountDimensionRule: 'accountdimensionrules',
  Agreement: 'agreements',
  ApprovalDelegation: 'approvaldelegations',
  ApprovalPolicy: 'approvalpolicies',
  ApprovalRequest: 'approvalrequests',
  AssignmentPolicy: 'assignmentpolicies',
  BatchJob: 'batchjobs',
  BatchJobRun: 'batchjobruns',
  BusinessRule: 'businessrules',
  CompanyProfile: 'companyprofiles',
  Country: 'countries',
  Currency: 'currencies',
  Customer: 'customers',
  CustomerGroup: 'customergroups',
  DeliveryTerms: 'deliveryterms',
  DimensionDefinition: 'dimensiondefinitions',
  DimensionSet: 'dimensionsets',
  DimensionValue: 'dimensionvalues',
  DistributionProfile: 'distributionprofiles',
  DocumentPageSetup: 'documentpagesetups',
  DocumentTemplate: 'documenttemplates',
  EntityTemplate: 'entitytemplates',
  EnumValue: 'enumvalues',
  FieldRestrictionSet: 'fieldrestrictionsets',
  FinanceAccountGroup: 'financeaccountgroups',
  FiscalPeriod: 'fiscalperiods',
  FiscalYear: 'fiscalyears',
  ImportProfile: 'importprofiles',
  InboundMeasuringTicket: 'inboundmeasuringtickets',
  IntegrationClient: 'integrationclients',
  IntegrationConnection: 'integrationconnections',
  IntegrationJob: 'integrationjobs',
  IntegrationOutboxRecord: 'integrationoutboxrecords',
  IntegrationRun: 'integrationruns',
  IntegrationStagingRecord: 'integrationstagingrecords',
  InternalPriceList: 'internalpricelists',
  InventoryOnHand: 'inventoryonhands',
  InventoryPeriodClose: 'inventoryperiodcloses',
  InventoryPostingProfile: 'inventorypostingprofiles',
  InventoryProductGroup: 'inventoryproductgroups',
  InventoryReservation: 'inventoryreservations',
  InventoryTransaction: 'inventorytransactions',
  InventoryValueEntry: 'inventoryvalueentries',
  InventoryVarianceEntry: 'inventoryvarianceentries',
  Invoice: 'invoices',
  LoadObservation: 'loadobservations',
  NumberSeries: 'numberseries',
  Order: 'orders',
  OrgRoleFunction: 'orgrolefunctions',
  OrgUnit: 'orgunits',
  Organization: 'organizations',
  OwnerDerivationRule: 'ownerderivationrules',
  PaymentTerms: 'paymentterms',
  PlanHeader: 'planheaders',
  PlanLine: 'planlines',
  PlanLineReevaluationRun: 'planlinereevaluationruns',
  PlanLineReevaluationRunItem: 'planlinereevaluationrunitems',
  PlanLineSnapshot: 'planlinesnapshots',
  PlanScenario: 'planscenarios',
  PlanStatementTemplate: 'planstatementtemplates',
  PlanVersion: 'planversions',
  PlanVersionPublishRun: 'planversionpublishruns',
  PlanView: 'planviews',
  PriceList: 'pricelists',
  Product: 'products',
  Project: 'projects',
  SetupPackage: 'setuppackages',
  StandardCostVersion: 'standardcostversions',
  Supplier: 'suppliers',
  TradeType: 'tradetypes',
  UnitOfMeasure: 'unitofmeasures',
  VatCode: 'vatcodes',
  WorkTask: 'worktasks',
  Workorder: 'workorders',
};

/**
 * The root query key for an entity name, or undefined when the entity has no
 * generated hooks. Callers treat undefined as "nothing to do" rather than guessing.
 */
export function queryKeyRootForEntity(entityName: string): string | undefined {
  return entityQueryKeyRoots[entityName];
}
